module.exports = __webpack_public_path__ + "static/media/contact.07655616.svg";